const Utils = {
  getTallyText(value, max, asPercent) {
    asPercent = asPercent || false;
    let text;
    if (max == 0) {
      text = 'N/A';
    } else {
      const valueText = value === null ? '-' : Math.round10(value, -1);
      if (asPercent) {
        text = `${valueText}%`;
      } else {
        text = `${valueText}/${Math.round10(max, -1)}`;
      }
    }
    return text;
  },
};

export default Utils;
